import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { LoftHandHeadModel } from '../../api/models/LoftsByHandAndHeadModel';

export type TABLE_TYPE = Table<LoftHandHeadModel>;

export const TABLE = 'loftsAndHandAndHeadModel';
const SCHEMA = '&headLoftHandId';

class LoftDatabase implements DataRepository<LoftHandHeadModel> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<LoftHandHeadModel | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: LoftHandHeadModel, key: Key): Promise<LoftHandHeadModel> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: LoftHandHeadModel[]): Promise<LoftHandHeadModel[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<LoftHandHeadModel[]> {
    return this.db[TABLE].toArray();
  }
}

export const LoftsAndHandAndHeadModelDB = new LoftDatabase(db);
